import ProviderIcon from '../../../icons/provider.svg'

export const PROVIDER_SEARCH_ITEM_ICON = { Icon: ProviderIcon }
